import config from '_config';
import axiosHeader from '_common/runs/axios';
import axios from 'axios';

class GoogleApiService {
  getApiKey() {
    const apiKey = config.GOOGLE_API_KEY;
    if (!apiKey || apiKey === '') return null;
    return apiKey;
  }

  getAddressGeocoding(address) {
    const formattedAddress = encodeURIComponent(
      [
        address.zipcode,
        address.street,
        address.number,
        address.complement,
        address.neighborhood,
        address.city,
        address.state,
      ]
        .filter(Boolean)
        .join(' ')
    );

    const apiKey = this.getApiKey();

    if (!formattedAddress || !apiKey) {
      return Promise.resolve([]);
    }

    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${apiKey}`;
    axios.defaults.headers.common = {};

    return axios
      .get(url)
      .then(response => response.data.results)
      .finally(() => {
        axiosHeader();
      });
  }

  getAddressCoordinates(address) {
    return this.getAddressGeocoding(address)
      .then(results => {
        if (!results || results.length === 0) return null;
        return results[0]?.geometry?.location;
      })
      .catch(() => null);
  }
}

export default new GoogleApiService();
